import { FC, useMemo, useCallback } from 'react'
import Button from 'components/features/pfm/Button/Button'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { killFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { SubscriptionPanePreset } from 'components/features/pfm/SubscriptionPane/SubscriptionPanePreset'


export const SubscriptionDonePane: FC<{}> = () => {

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    dispatch(killFloatingPanesActionCreator('subscription'))
  }, [dispatch])

  const closeButtonChild = useMemo(() => (
    <Button
      text='Close'
      qaMarker='save-button'
      onClick={ handleClose }
    />
  ), [handleClose])

  const linkChild = useMemo(() => (
    <NavigationLink to='settings_subscription' onClick={ handleClose }>
      Settings screen
    </NavigationLink>
  ), [handleClose])

  return useMemo(() => (
    <SubscriptionPanePreset
      title='All Done!'
      subTitle={ <>Thank you for being a valuable <br />member of the community.  </> }
      primaryButton={ closeButtonChild }
      cardLayout
    >
      <p>
        You can manage your membership <br />
        from the { linkChild }.
      </p>
    </SubscriptionPanePreset>
  ), [closeButtonChild, linkChild])
}
